module.exports = __webpack_public_path__ + "mo/img/modal-img.cdae9a21.jpg";